import type { AnchorHTMLAttributes } from "react";
import { forwardRef } from "react";
import { cn } from "@renewmap/ui/utils/class-name";

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  asChild?: boolean;
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <a
        ref={ref}
        className={cn(
          "text-link focus-visible:ring-ring underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
          className,
        )}
        {...props}
      >
        {children}
      </a>
    );
  },
);
Link.displayName = "Link";

export { Link };
